import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
type TimeLeft = {
  hours: string;
  minutes: string;
  seconds: string;
  expired: boolean;
};
const CountdownContext = createContext<TimeLeft>({
  hours: '00',
  minutes: '00',
  seconds: '00',
  expired: false
});
type CountdownProviderProps = {
  endISO: string;
  children: React.ReactNode;
};
export function CountdownProvider({
  endISO,
  children
}: CountdownProviderProps) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const value = useMemo(() => {
    const target = getTarget(endISO, now);
    const diff = Math.max(0, target - now);
    const totalSeconds = Math.floor(diff / 1000);
    return {
      hours: pad(Math.floor(totalSeconds / 3600)),
      minutes: pad(Math.floor(totalSeconds % 3600 / 60)),
      seconds: pad(totalSeconds % 60),
      expired: diff === 0
    };
  }, [endISO, now]);
  return <CountdownContext.Provider value={value} data-id="element-275" data-mp="3g4965ica0a72">{children}</CountdownContext.Provider>;
}
export function useCountdown() {
  return useContext(CountdownContext);
}
function getTarget(endISO: string, now: number) {
  const parsed = endISO ? new Date(endISO).getTime() : NaN;
  if (!Number.isNaN(parsed)) return parsed;
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  return midnight.getTime();
}
function pad(n: number) {
  return String(n).padStart(2, '0');
}